"use client";

import Image from "next/image";
import Button from "@/components/ui/Button";
import styles from "./LpHero.module.css";

const IMG_HERO = "/images/simob/simob-home.png";

export default function LpHero() {
    const handleScroll = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <section className={styles.hero}>
            <div className={styles.container}>
                <div className={styles.textContent}>
                    <h1 className={styles.title}>
                        Organize sua imobiliária, automatize o previsível e tenha controle total da operação
                    </h1>
                    <p className={styles.description}>
                        O SIMOB centraliza locação, vendas, financeiro e processos em um único sistema. Menos retrabalho, mais previsibilidade e decisões baseadas em dados.
                    </p>
                    <Button onClick={() => handleScroll('contato')}>Solicitar demonstração</Button>
                </div>

                <div className={styles.imageContainer}>
                    <Image
                        src={IMG_HERO}
                        alt="Painel de gestão imobiliária SIMOB"
                        className={styles.image}
                        width={691}
                        height={389}
                        style={{ width: '100%', height: 'auto' }}
                        priority
                    />
                </div>
            </div>
        </section>
    );
}
